import type { UseTranslationResponse } from 'react-i18next';
import { useTranslation } from 'react-i18next';

export const ns = 'source-live-page';
export const useSourceLivePageTranslation = (): UseTranslationResponse<typeof ns> => useTranslation(ns);

export const ruRu = {
  sourceLivePage: {
    breadcrumb_sources: 'Источники',
    translation: 'Трансляция',
    connect: 'Подключение',
    events: 'События',
    map: 'Показать на карте',
    quality_original: 'Оригинал',
    quality_original_value: 'Оригинал ({{quality}} p)',
    quality_480: '480 p',
    quality_720: '720 p',
    quality_1080: '1080 p',
    video_unavailable: 'Видео недоступно',
    try_later_or_reconnect: 'Попробуйте позже или переподключите трансляцию',
    unsupported_type: 'Тип потока не поддерживает трансляцию',
    no_events: 'Нет событий',
    load_error: 'Не удалось загрузить источник',
    back_to_list: 'Вернуться к источникам',
    location_title: 'Location',
    longitude: 'Долгота',
    latitude: 'Широта',
    fullscreen_enter: 'Полноэкранный режим',
    fullscreen_exit: 'Выйти из полноэкранного режима',
  },
};

export const en = {
  sourceLivePage: {
    breadcrumb_sources: 'Sources',
    translation: 'Live stream',
    connect: 'Connect',
    events: 'Events',
    map: 'Show on map',
    quality_original: 'Original',
    quality_original_value: 'Original ({{quality}} p)',
    quality_480: '480 p',
    quality_720: '720 p',
    quality_1080: '1080 p',
    video_unavailable: 'Video unavailable',
    try_later_or_reconnect: 'Try again later or reconnect the stream',
    unsupported_type: 'This stream type does not support live streaming',
    no_events: 'No events',
    load_error: 'Failed to load the stream',
    back_to_list: 'Back to sources',
    location_title: 'Location',
    longitude: 'Longitude',
    latitude: 'Latitude',
    fullscreen_enter: 'Fullscreen',
    fullscreen_exit: 'Exit fullscreen',
  },
};

export const esEs = {
  sourceLivePage: {
    breadcrumb_sources: 'Fuentes',
    translation: 'Transmisión',
    connect: 'Conectar',
    events: 'Eventos',
    map: 'Mostrar en el mapa',
    quality_original: 'Original',
    quality_original_value: 'Original ({{quality}} p)',
    quality_480: '480 p',
    quality_720: '720 p',
    quality_1080: '1080 p',
    video_unavailable: 'Video no disponible',
    try_later_or_reconnect: 'Inténtalo más tarde o reconecta la transmisión',
    unsupported_type: 'Este tipo de flujo no admite transmisión',
    no_events: 'Sin eventos',
    load_error: 'No se pudo cargar la fuente',
    back_to_list: 'Volver a fuentes',
    location_title: 'Location',
    longitude: 'Longitud',
    latitude: 'Latitud',
    fullscreen_enter: 'Pantalla completa',
    fullscreen_exit: 'Salir de pantalla completa',
  },
};

export const ptBr = {
  sourceLivePage: {
    breadcrumb_sources: 'Fontes',
    translation: 'Transmissão',
    connect: 'Conectar',
    events: 'Eventos',
    map: 'Mostrar no mapa',
    quality_original: 'Original',
    quality_original_value: 'Original ({{quality}} p)',
    quality_480: '480 p',
    quality_720: '720 p',
    quality_1080: '1080 p',
    video_unavailable: 'Vídeo indisponível',
    try_later_or_reconnect: 'Tente novamente mais tarde ou reconecte a transmissão',
    unsupported_type: 'Este tipo de fluxo não suporta transmissão',
    no_events: 'Sem eventos',
    load_error: 'Falha ao carregar a fonte',
    back_to_list: 'Voltar às fontes',
    location_title: 'Location',
    longitude: 'Longitude',
    latitude: 'Latitude',
    fullscreen_enter: 'Tela cheia',
    fullscreen_exit: 'Sair da tela cheia',
  },
};
